import React, { useEffect } from 'react'
import classes from "./styles/RightSidebar.module.css";
import { RightSideWiraaAds } from './Ads/RightSideWiraaAds';
import LeftSidebar from './LeftSidebar';
const RightSidebar = () => {
  
    useEffect(() => {
      // Initialize Google Ads
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        console.error("AdSense run successfully");
      } catch (e) {
        console.error("AdSense error", e);
      }
    }, []);

  return (
    <div className={classes.container}>
    <RightSideWiraaAds/>
    <div className={classes.leftSidebar}>
      <LeftSidebar/>
    </div>
     
    </div>
  )
}

export default RightSidebar;
